import { render, staticRenderFns } from "./interData.vue?vue&type=template&id=659146cf&scoped=true&"
import script from "./interData.vue?vue&type=script&lang=js&"
export * from "./interData.vue?vue&type=script&lang=js&"
import style0 from "./interData.vue?vue&type=style&index=0&id=659146cf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659146cf",
  null
  
)

export default component.exports